module.exports = __webpack_public_path__ + "img/one.939e4d9b.png";